/**
 * Client-side JavaScript: Core Rendering.
 * Utilities, data transformation, summary, test grid, drawer, and artifacts.
 */

export const JS_RENDER = `
  /* ── Utilities ── */
  function esc(s){if(!s)return '';return String(s).replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;').replace(/'/g,'&#39;')}
  function stripAnsi(s){return s?s.replace(/\\u001b\\[[0-9;]*m/g,'').replace(/\\x1b\\[[0-9;]*m/g,''):''}
  function fmtDur(ms){if(ms<1000)return Math.round(ms)+'ms';if(ms<60000)return (ms/1000).toFixed(1)+'s';var m=Math.floor(ms/60000),s=Math.round((ms%60000)/1000);return s>0?m+'m '+s+'s':m+'m'}
  function fmtBytes(b){if(b===0)return '0 B';if(b<1024)return b+' B';if(b<1048576)return (b/1024).toFixed(1)+' KB';return (b/1048576).toFixed(1)+' MB'}
  function fmtDate(iso){try{return new Date(iso).toLocaleString()}catch(e){return iso}}
  function shortTitle(t){var p=t.split(' > ');return p.length>1?p[p.length-1]:t}

  /* ── Data Transformation ── */
  var testMap={};
  for(var i=0;i<data.timeline.length;i++){
    var entry=data.timeline[i];
    for(var j=0;j<entry.tests.length;j++){
      var t=entry.tests[j];
      if(!testMap[t.testId]){
        testMap[t.testId]={
          testId:t.testId,title:t.title,status:t.status,duration:t.duration,
          startedAt:t.startedAt,completedAt:t.completedAt,retryCount:t.retryCount,
          tags:t.tags,failure:t.failure,filePath:t.filePath,suiteName:t.suiteName,
          testType:t.testType,isFlaky:t.isFlaky,retryStatus:t.retryStatus,
          expectedStatus:t.expectedStatus,actualStatus:t.actualStatus,
          artifacts:t.artifacts,networkRequests:t.networkRequests||[],steps:[],apiCalls:[],actions:t.actions||[],consoleLogs:t.consoleLogs||[]
        };
      }
      if(entry.type==='api_call'){
        testMap[t.testId].apiCalls.push({
          callId:entry.callId,method:entry.method,url:entry.url,
          responseTime:entry.responseTime,timestamp:entry.timestamp,
          request:entry.request,response:entry.response,assertions:entry.assertions
        });
      }else{
        testMap[t.testId].steps.push({
          url:entry.url,navigationType:entry.navigationType,
          visitedAt:entry.visitedAt||entry.timestamp,duration:entry.duration||entry.durationOnUrl||0,specFile:entry.specFile,
          domContentLoadedAt:entry.domContentLoadedAt,networkIdleAt:entry.networkIdleAt,
          networkStats:entry.networkStats
        });
      }
    }
  }
  var tests=[];
  for(var id in testMap){if(testMap.hasOwnProperty(id))tests.push(testMap[id])}
  tests.sort(function(a,b){
    if(a.filePath!==b.filePath)return a.filePath<b.filePath?-1:1;
    return a.startedAt<b.startedAt?-1:1;
  });

  /* ── Streaming mode: build tests from compact index ── */
  if(data.reportMode==='streaming'&&data.index&&data.index.length>0){
    tests=[];testMap={};
    for(var xi=0;xi<data.index.length;xi++){
      var ix=data.index[xi];
      if(ix.isRetry)continue;
      var st={
        testId:ix.id,title:ix.title,status:ix.status,duration:ix.duration,
        filePath:ix.filePath,tags:ix.tags||[],isFlaky:ix.status==='flaky',
        testType:'e2e',retryCount:0,suiteName:'',
        startedAt:'',completedAt:'',
        networkRequests:[],steps:[],apiCalls:[],actions:[],consoleLogs:[],
        artifacts:null,failure:null,retryStatus:null,expectedStatus:null,actualStatus:null,
        hasNetworkData:ix.hasNetworkData,hasConsoleData:ix.hasConsoleData,
        hasActionSteps:ix.hasActionSteps,hasArtifacts:ix.hasArtifacts,
        errorMessage:ix.errorMessage,networkCount:ix.networkCount||0,
        consoleCount:ix.consoleCount||0,actionCount:ix.actionCount||0
      };
      testMap[st.testId]=st;
      tests.push(st);
    }
    tests.sort(function(a,b){
      if(a.filePath!==b.filePath)return a.filePath<b.filePath?-1:1;
      return 0;
    });
  }

  /* ── Streaming detail cache (LRU, max 50 entries) ── */
  var _detailCache={};
  var _detailCacheKeys=[];
  var _detailCacheMax=50;
  function cacheDetail(testId,data){
    if(_detailCache[testId]){
      var ki=_detailCacheKeys.indexOf(testId);
      if(ki>-1)_detailCacheKeys.splice(ki,1);
    }else if(_detailCacheKeys.length>=_detailCacheMax){
      var evict=_detailCacheKeys.shift();
      delete _detailCache[evict];
    }
    _detailCache[testId]=data;
    _detailCacheKeys.push(testId);
  }

  /* ── State ── */
  var searchQuery='';

  /* ── DOM Refs ── */
  var runMetaEl=document.getElementById('run-meta');
  var summaryEl=document.getElementById('summary-strip');
  var filterEl=document.getElementById('filter-bar');
  var testGridEl=document.getElementById('test-grid');
  var drawerEl=document.getElementById('drawer');
  var drawerBodyEl=document.getElementById('drawer-body');
  var drawerBackdropEl=document.getElementById('drawer-backdrop');

  /* ── Render: Run Meta ── */
  function renderRunMeta(){
    var h='';
    h+='<div class="run-meta-item"><span class="run-meta-label">Run</span><span class="run-id-tag">'+esc(data.testRunId.substring(0,8))+'</span></div>';
    h+='<div class="run-meta-item"><span class="run-meta-label">Duration</span>'+fmtDur(data.totalDuration)+'</div>';
    h+='<div class="run-meta-item">'+fmtDate(data.startedAt)+'</div>';
    if(data.ci){
      h+='<div class="run-meta-item"><span class="ci-tag">'+esc(data.ci.provider)+'</span></div>';
      if(data.ci.branch)h+='<div class="run-meta-item"><span class="run-meta-label">Branch</span>'+esc(data.ci.branch)+'</div>';
      if(data.ci.commitSha)h+='<div class="run-meta-item"><span class="run-meta-label">Commit</span><span class="run-id-tag">'+esc(data.ci.commitSha.substring(0,8))+'</span></div>';
    }
    if(data.shardRunIds&&data.shardRunIds.length>0){
      h+='<div class="run-meta-item"><span class="merged-tag">Merged ('+data.shardRunIds.length+' shards)</span></div>';
    }
    runMetaEl.innerHTML=h;
  }

  /* ── Render: Summary ── */
  function renderSummary(){
    var s=data.summary;var h='';
    h+='<div class="summary-chip s-total"><div class="s-count">'+s.total+'</div><div class="s-label">Total</div></div>';
    h+='<div class="summary-chip s-passed"><div class="s-count">'+s.passed+'</div><div class="s-label">Passed</div></div>';
    h+='<div class="summary-chip s-failed"><div class="s-count">'+s.failed+'</div><div class="s-label">Failed</div></div>';
    h+='<div class="summary-chip s-flaky"><div class="s-count">'+s.flaky+'</div><div class="s-label">Flaky</div></div>';
    h+='<div class="summary-chip s-skipped"><div class="s-count">'+s.skipped+'</div><div class="s-label">Skipped</div></div>';
    if(s.timedout!==undefined)h+='<div class="summary-chip s-timedout"><div class="s-count">'+s.timedout+'</div><div class="s-label">Timeout</div></div>';
    summaryEl.innerHTML=h;
  }

  /* ── Virtual Grid: progressive chunked rendering ── */
  var _vgGroups=[];
  var _vgRenderedTo=0;
  var _vgChunkSize=10;
  var _vgSentinel=null;
  var _vgObserver=null;

  function _vgBuildGroups(filtered){
    var groups=[];var lastFile='';var g=null;
    for(var i=0;i<filtered.length;i++){
      var t=filtered[i];
      if(t.filePath!==lastFile){
        g={filePath:t.filePath,tests:[]};
        groups.push(g);
        lastFile=t.filePath;
      }
      g.tests.push(t);
    }
    return groups;
  }

  function _vgRenderGroupHtml(g){
    var h='<div class="file-group">';
    h+='<div class="file-group-header">'+esc(g.filePath)+'</div>';
    h+='<div class="file-group-card">';
    for(var i=0;i<g.tests.length;i++){
      var t=g.tests[i];
      h+='<div class="test-row" data-testid="'+esc(t.testId)+'">';
      h+='<div class="status-indicator si-'+t.status+'"></div>';
      h+='<div class="test-row-info">';
      h+='<div class="test-row-title" title="'+esc(t.title)+'">'+esc(shortTitle(t.title))+'</div>';
      var hasBadges=(t.testType&&t.testType!=='unknown')||t.isFlaky||(t.tags&&t.tags.length>0);
      if(hasBadges){
        h+='<div class="test-row-badges">';
        if(t.testType&&t.testType!=='unknown')h+='<span class="trb trb-type">'+esc(t.testType)+'</span>';
        if(t.isFlaky)h+='<span class="trb trb-flaky">flaky</span>';
        if(t.retryCount>0)h+='<span class="trb trb-retry">'+t.retryCount+' retries</span>';
        if(t.tags){for(var ti=0;ti<t.tags.length;ti++){if(t.tags[ti])h+='<span class="trb trb-tag">'+esc(t.tags[ti])+'</span>';}}
        h+='</div>';
      }
      h+='</div>';
      h+='<span class="test-row-dur">'+fmtDur(t.duration)+'</span>';
      h+='<svg class="test-row-arrow" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M9 18l6-6-6-6"/></svg>';
      h+='</div>';
    }
    h+='</div></div>';
    return h;
  }

  function _vgRenderChunk(){
    if(_vgRenderedTo>=_vgGroups.length){
      if(_vgSentinel)_vgSentinel.style.display='none';
      return;
    }
    var end=Math.min(_vgRenderedTo+_vgChunkSize,_vgGroups.length);
    var frag=document.createDocumentFragment();
    var tmp=document.createElement('div');
    var h='';
    for(var i=_vgRenderedTo;i<end;i++){h+=_vgRenderGroupHtml(_vgGroups[i]);}
    tmp.innerHTML=h;
    while(tmp.firstChild)frag.appendChild(tmp.firstChild);
    /* Insert before sentinel */
    if(_vgSentinel&&_vgSentinel.parentNode){
      _vgSentinel.parentNode.insertBefore(frag,_vgSentinel);
    }
    _vgRenderedTo=end;
    if(_vgRenderedTo>=_vgGroups.length&&_vgSentinel){
      _vgSentinel.style.display='none';
    }
  }

  function _vgSetupObserver(){
    if(_vgObserver){_vgObserver.disconnect();_vgObserver=null;}
    if(!_vgSentinel)return;
    if(typeof IntersectionObserver==='undefined'){
      /* Fallback: render everything */
      while(_vgRenderedTo<_vgGroups.length)_vgRenderChunk();
      return;
    }
    _vgObserver=new IntersectionObserver(function(entries){
      if(entries[0].isIntersecting)_vgRenderChunk();
    },{rootMargin:'600px'});
    _vgObserver.observe(_vgSentinel);
  }

  /* ── Render: Test Grid ── */
  function renderTestGrid(){
    if(_vgObserver){_vgObserver.disconnect();_vgObserver=null;}
    var filtered=getFilteredTests();
    if(filtered.length===0){testGridEl.innerHTML='<div class="no-tests">No tests match your filters</div>';_vgGroups=[];return;}
    _vgGroups=_vgBuildGroups(filtered);
    _vgRenderedTo=0;
    /* Render initial batch directly, then progressively load the rest */
    var initCount=Math.min(_vgChunkSize,_vgGroups.length);
    var h='';
    for(var i=0;i<initCount;i++){h+=_vgRenderGroupHtml(_vgGroups[i]);}
    _vgRenderedTo=initCount;
    h+='<div class="vg-sentinel" id="vg-sentinel"></div>';
    testGridEl.innerHTML=h;
    _vgSentinel=document.getElementById('vg-sentinel');
    if(_vgRenderedTo<_vgGroups.length){
      _vgSetupObserver();
    }else if(_vgSentinel){
      _vgSentinel.style.display='none';
    }
  }

  /* ── Render helpers (code, artifacts) ── */

  function renderCodeSnippet(code){
    var lines=code.split('\\n');var out='<div class="code-snippet">';
    for(var k=0;k<lines.length;k++){var raw=lines[k];var numMatch=raw.match(/^\\s*(>?\\s*)(\\d+)\\s*\\|/);var lineNum=numMatch?numMatch[2]:'';var isHighlight=raw.trimStart().startsWith('>');var codePart=raw.replace(/^\\s*>?\\s*\\d+\\s*\\|/,'');out+='<div class="code-line'+(isHighlight?' highlight':'')+'"><span class="line-num">'+esc(lineNum)+'</span><span class="line-code">'+esc(codePart)+'</span></div>';}
    out+='</div>';return out;
  }

  function renderArtifactColumn(artifacts){
    if(!artifacts)return '<div class="artifact-empty">No artifacts captured</div>';
    var hasS=!!artifacts.screenshot,hasV=!!artifacts.video;
    if(!hasS&&!hasV)return '<div class="artifact-empty">No artifacts captured</div>';
    var h='';
    if(hasS&&hasV){
      h+='<div class="seg-ctrl" data-seg-group="artifacts">';
      h+='<button class="seg-btn active" data-seg="screenshot"><svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="3" y="3" width="18" height="18" rx="2"/><circle cx="8.5" cy="8.5" r="1.5"/><path d="M21 15l-5-5L5 21"/></svg>Screenshot</button>';
      h+='<button class="seg-btn" data-seg="video"><svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polygon points="5 3 19 12 5 21"/></svg>Video</button>';
      h+='</div>';
    }
    if(hasS){h+='<div class="seg-pane active" data-seg-pane="screenshot"><img class="artifact-col-img" src="'+esc(artifacts.screenshot)+'" loading="lazy" alt="Screenshot"><div class="artifact-col-caption"><svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M15 3h6v6M9 21H3v-6M21 3l-7 7M3 21l7-7"/></svg>Click to enlarge</div></div>';}
    if(hasV){h+='<div class="seg-pane'+(hasS?'':' active')+'" data-seg-pane="video"><div class="artifact-col-video"><video controls preload="metadata" src="'+esc(artifacts.video)+'"></video></div></div>';}
    return h;
  }

  /* ── Render: Drawer Content ── */
  function renderDrawer(testId,detail){
    var t=detail||testMap[testId];
    if(!t){drawerBodyEl.innerHTML='';return;}
    var h='<div class="test-detail">';

    /* ── Top: Metadata ── */
    h+='<div class="test-detail-header"><div class="test-detail-top">';
    h+='<span class="detail-status-badge dbg-'+t.status+'">'+t.status+'</span>';
    h+='<div class="detail-title-section"><div class="detail-title">'+esc(t.title)+'</div><div class="detail-meta">';
    if(t.testType&&t.testType!=='unknown')h+='<span class="dm-badge dm-type">'+esc(t.testType)+'</span>';
    if(t.isFlaky)h+='<span class="dm-badge dm-flaky">Flaky</span>';
    if(t.retryCount>0)h+='<span class="dm-badge dm-retry">'+t.retryCount+' retries</span>';
    if(t.retryStatus)h+='<span class="dm-badge dm-retry">'+esc(t.retryStatus)+'</span>';
    if(t.tags&&t.tags.length>0){for(var ti=0;ti<t.tags.length;ti++){if(t.tags[ti])h+='<span class="dm-badge dm-tag">'+esc(t.tags[ti])+'</span>';}}
    if(t.expectedStatus&&t.actualStatus&&t.expectedStatus!==t.actualStatus)h+='<span class="dm-badge" style="background:rgba(239,68,68,0.12);color:#ef4444">expected: '+esc(t.expectedStatus)+' actual: '+esc(t.actualStatus)+'</span>';
    h+='</div>';
    if(t.testId||t.filePath||t.suiteName){h+='<div class="detail-sub-meta">';if(t.testId)h+='<span><span class="meta-k">ID</span><span class="detail-id" title="'+esc(t.testId)+'">'+esc(t.testId.substring(0,12))+'</span></span>';if(t.filePath)h+='<span><span class="meta-k">File</span><span class="detail-file">'+esc(t.filePath)+'</span></span>';if(t.suiteName)h+='<span><span class="meta-k">Suite</span><span class="detail-suite">'+esc(t.suiteName)+'</span></span>';h+='</div>';}
    h+='</div><div class="detail-duration">'+fmtDur(t.duration)+'</div></div></div>';

    /* ── Failure panel (full width) ── */
    if((t.status==='failed'||t.status==='flaky')&&t.failure)h+=renderFailure(t.failure,t.filePath,t.title,t.tags);
    else if(t.status==='failed'&&!t.failure)h+='<div style="margin-bottom:20px;padding:14px;background:var(--bg-2);border:1px solid var(--bd);border-radius:10px;font-size:12px;color:var(--fg-2);font-style:italic">No diagnostic information available</div>';

    /* ── Stacked sections: 1) Artifacts  2) Timeline / Network  3) API Calls ── */
    var hasArt=t.artifacts&&(t.artifacts.screenshot||t.artifacts.video);
    var hasSteps=t.steps&&t.steps.length>0;
    var hasApiCalls=t.apiCalls&&t.apiCalls.length>0;
    var hasActions=t.actions&&t.actions.length>0;
    var hasConsoleLogs=t.consoleLogs&&t.consoleLogs.length>0;
    var hasNetworkReqs=t.networkRequests&&t.networkRequests.length>0;
    var hasVideo=!!(t.artifacts&&t.artifacts.video);
    /* Compute base time for video offset calculation (console/network) */
    var baseTime=0;
    if(hasVideo&&t.startedAt){baseTime=Date.parse(t.startedAt);}
    if(!baseTime&&hasVideo&&t.consoleLogs&&t.consoleLogs.length>0&&t.consoleLogs[0].timestamp){baseTime=Date.parse(t.consoleLogs[0].timestamp);}
    if(hasArt||hasSteps||hasApiCalls||hasActions||hasConsoleLogs||hasNetworkReqs){
      h+='<div class="drawer-sections">';
      if(hasArt)h+='<div class="drawer-section">'+renderArtifactColumn(t.artifacts)+'</div>';
      if(hasActions)h+='<div class="drawer-section">'+renderActionsColumn(t.actions,hasVideo)+'</div>';
      if(hasSteps){var _pgMeta=t._networkTotal?{testId:t._testId,page:t._networkPage||1,total:t._networkTotal,pageSize:t._networkPageSize||500}:null;h+='<div class="drawer-section">'+renderTimelineColumn(t.steps,t.networkRequests,t.consoleLogs,t.testType,hasVideo,baseTime,_pgMeta)+'</div>';}
      if(!hasSteps&&hasNetworkReqs&&typeof renderNetworkDevTools==='function'){var _pgMeta2=t._networkTotal?{testId:t._testId,page:t._networkPage||1,total:t._networkTotal,pageSize:t._networkPageSize||500}:null;h+='<div class="drawer-section">'+renderNetworkDevTools(t.networkRequests,false,0,_pgMeta2)+'</div>';}
      if(!hasSteps&&hasConsoleLogs)h+='<div class="drawer-section">'+renderConsoleColumn(t.consoleLogs,t.testType,hasVideo,baseTime)+'</div>';
      if(hasApiCalls)h+='<div class="drawer-section">'+renderApiCallsColumn(t.apiCalls)+'</div>';
      h+='</div>';
    }

    h+='</div>';
    drawerBodyEl.innerHTML=h;
    drawerBodyEl.scrollTop=0;
    /* Wire up video ↔ action step sync if both are present */
    if(typeof syncActionsWithVideo==='function')syncActionsWithVideo();
  }

  /* ── Drawer open / close ── */
  function openDrawer(testId){
    if(data.reportMode==='streaming'){
      drawerEl.classList.add('open');
      drawerBackdropEl.classList.add('open');
      document.body.style.overflow='hidden';
      if(_detailCache[testId]){renderDrawer(testId,_detailCache[testId]);return;}
      drawerBodyEl.innerHTML='<div class="detail-loading"><div class="loading-spinner"></div><div class="loading-text">Loading test details...</div></div>';
      if(window.__trStreamingFetchDetail){
        window.__trStreamingFetchDetail(testId,function(err,detail){
          if(err){
            var t=testMap[testId];
            var emsg=t&&t.errorMessage?'<div class="failure-message">'+esc(t.errorMessage)+'</div>':'';
            drawerBodyEl.innerHTML='<div class="detail-error">'+emsg+'<p>Server unavailable &mdash; run <code>npx testrelic serve &lt;path&gt;</code> to view full details</p></div>';
            return;
          }
          /* Merge index entry with server detail metadata */
          var idx=testMap[testId]||{};
          var merged={};
          var k;for(k in idx){if(idx.hasOwnProperty(k))merged[k]=idx[k];}
          merged.actions=detail.actions||[];
          merged.apiAssertions=detail.apiAssertions||[];
          merged.artifacts=detail.artifacts||null;
          merged.failure=detail.failureDiagnostic||detail.failure||null;
          merged.steps=detail.navigations||[];
          if(detail.startedAt)merged.startedAt=detail.startedAt;
          /* Mark counts for lazy loading */
          merged._networkCount=detail.networkRequestsCount||idx.networkCount||0;
          merged._consoleCount=detail.consoleLogsCount||idx.consoleCount||0;
          merged._apiCallsCount=detail.apiCallsCount||0;
          merged._testId=testId;
          /* Initially empty — loaded on demand */
          merged.networkRequests=[];
          merged.consoleLogs=[];
          merged.apiCalls=[];
          cacheDetail(testId,merged);
          renderDrawer(testId,merged);
          /* Lazy-load heavy data after drawer is visible */
          loadHeavyData(testId,merged);
        });
      }else{
        var t=testMap[testId];
        var emsg=t&&t.errorMessage?'<div class="failure-message">'+esc(t.errorMessage)+'</div>':'';
        drawerBodyEl.innerHTML='<div class="detail-error">'+emsg+'<p>Server unavailable &mdash; run <code>npx testrelic serve &lt;path&gt;</code> to view full details</p></div>';
      }
      return;
    }
    renderDrawer(testId);
    drawerEl.classList.add('open');
    drawerBackdropEl.classList.add('open');
    document.body.style.overflow='hidden';
  }

  /* Lazy-load heavy data (network, console, API calls) after drawer renders */
  function loadHeavyData(testId,merged){
    var fetchData=window.__trFetchTestData;
    if(!fetchData)return;
    var pending=0;
    var loaded=0;
    function onLoaded(){loaded++;if(loaded>=pending){renderDrawer(testId,merged);}}
    /* Load first page of network requests */
    if(merged._networkCount>0){
      pending++;
      fetchData(testId,'network',1,500,function(err,result){
        if(!err&&result){
          merged.networkRequests=result.items;
          merged._networkTotal=result.total;
          merged._networkPage=1;
          merged._networkPageSize=result.pageSize;
          merged._networkLoading=false;
        }
        onLoaded();
      });
    }
    /* Load first page of console logs */
    if(merged._consoleCount>0){
      pending++;
      fetchData(testId,'console',1,500,function(err,result){
        if(!err&&result){
          merged.consoleLogs=result.items;
          merged._consoleTotal=result.total;
          merged._consolePage=1;
        }
        onLoaded();
      });
    }
    /* Load first page of API calls */
    if(merged._apiCallsCount>0){
      pending++;
      fetchData(testId,'api-calls',1,500,function(err,result){
        if(!err&&result){
          merged.apiCalls=result.items;
          merged._apiCallsTotal=result.total;
          merged._apiCallsPage=1;
        }
        onLoaded();
      });
    }
  }
  function closeDrawer(){
    drawerEl.classList.remove('open');
    drawerBackdropEl.classList.remove('open');
    document.body.style.overflow='';
    /* Pause any playing video */
    var v=drawerBodyEl.querySelector('video');
    if(v)v.pause();
  }

  /* ── Search (debounced) ── */
  var _searchTimer=0;
  function doSearch(q){
    clearTimeout(_searchTimer);
    _searchTimer=setTimeout(function(){searchQuery=q;applyFilters();},150);
  }
`;
